export function Toaster() {
  return <div id="toast-container" className="fixed top-4 right-4 z-50"></div>
}
